/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { OtpVerificationAttemptStatus } from './otpVerificationAttemptStatus';

export interface OtpAttemptStatus { 
    attempt_status: OtpVerificationAttemptStatus;
    request_otp_blocked_until?: Date;
    verification_attempts_limit_reached: boolean;
}